const r = {
  fontFamily: "sans-serif",
  fontSize: "sm",
  fontWeight: "regular",
  color: "text-tertiary"
}, t = {
  color: "text-error-primary"
};
export {
  r as hint,
  t as hintError
};
